import { memo, useCallback } from 'react';
import FJVideoRemoveBgControls from '../view/FJVideoRemoveBgControls';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import { useMemo } from 'react';
import FJConstant from '../../../../constants/FJConstant';

const FJVideoRemoveBgControlsContainer = memo(() => {
    useLocalStore();
    const dispatch = useDispatch();

    const totalTime = useSelector(state => state.videoBgRemover.totalTime);
    const currentTime = useSelector(state => state.videoBgRemover.currentTime);
    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const isPlaying = useSelector(state => state.videoBgRemover.isPlaying);
    const tracklets = useSelector(state => state.videoBgRemover.tracklets);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const hasPointLoading = useSelector(state => state.videoBgRemover.hasPointLoading);
    const isShowGuide = useSelector(state => state.guideModals.isShow);
    const isPreviewModalShow = useSelector(state => state.modals.previewModalData?.display);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const isDisabledKeyEvent = useMemo(() => {
        return isShowGuide || isPreviewModalShow || headerTabIndex !== FJConstant.CREATIONS;
    }, [isShowGuide, isPreviewModalShow, headerTabIndex]);

    const isDisabled = useMemo(() => {
        return customRemoverStatus !== FJConstant.DEFAULT || hasPointLoading;
    }, [customRemoverStatus, hasPointLoading]);

    const isShow = useMemo(() => {
        return !!editVideoInfo;
    }, [editVideoInfo]);

    const _seekVideo = useCallback(
        time => {
            dispatch(FJActionVideoRemoveBg.seekAction(time));
        },
        [dispatch],
    );

    const _play = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.playAction());
    }, [dispatch]);

    const _setVideoThumbnailCanvas = useCallback(
        canvas => {
            dispatch(FJActionVideoRemoveBg.setVideoThumbnailCanvasAction(canvas));
        },
        [dispatch],
    );

    const _pause = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    const _updateVideoThumbnail = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.updateVideoThumbnailAction());
    }, [dispatch]);

    if (headerTabIndex !== FJConstant.CREATIONS) return null;

    return (
        <FJVideoRemoveBgControls
            active={isShow}
            totalTime={totalTime}
            currentTime={currentTime}
            isPlaying={isPlaying}
            tracklets={tracklets}
            isDisabled={isDisabled}
            isDisabledKeyEvent={isDisabledKeyEvent}
            play={_play}
            pause={_pause}
            seekVideo={_seekVideo}
            setVideoThumbnailCanvas={_setVideoThumbnailCanvas}
            updateVideoThumbnail={_updateVideoThumbnail}
        />
    );
});

FJVideoRemoveBgControlsContainer.displayName = 'FJVideoRemoveBgControlsContainer';
export default FJVideoRemoveBgControlsContainer;
